import { EventBus, Events } from "jiffy-store";
import { api } from "jiffy-api";
import { track, registerMixpanel } from "jiffy-analytics";
import { submitErrorGA, submitSuccessGA } from "../deliver-to/deliver-to-ga-events";
import initDates from "./init-dates";
import selectors from "./selectors";

const $getActiveColorSlide = () => document.querySelector(selectors.global.ACTIVE_COLOR_SLIDE);
const $getProductPageContainer = () =>
  document.getElementById(selectors.global.PRODUCT_PAGE_CONTAINER);

const $getContainer = () => document.getElementById(selectors.local.CONTAINER);
const $getSpinner = () => $getContainer().querySelector(selectors.local.SPINNER);
const $getForm = () => $getContainer().querySelector(selectors.local.FORM);
const $getFormInput = () => $getForm().querySelector(selectors.local.FORM_INPUT);
const $getFormError = () => $getForm().querySelector(selectors.local.FORM_ERROR);

const toggleFormLoading = isLoading => {
  if (isLoading) {
    $getForm().classList.toggle("hidden", isLoading);
    $getSpinner().classList.toggle("shown", isLoading);
  } else {
    $getForm().classList.toggle("hidden", isLoading);
    $getSpinner().classList.toggle("shown", isLoading);
  }
};

const showError = message => {
  const msg = message !== undefined ? message : "Please enter a valid zipcode.";
  $getFormError().innerHTML = msg;
  toggleFormLoading(false);
  submitErrorGA("zipcode");
};

const trackPDPZipcode = zipcode => {
  const $productData = $getProductPageContainer();
  const $compositionData = $getActiveColorSlide();
  const $compositionNameData = $compositionData?.querySelector("[data-composition-name]");

  if ($productData && $compositionNameData) {
    const { realProductId: productId, productId: productName } = $productData.dataset;
    const { compositionId } = $compositionData.dataset;
    const { compositionName } = $compositionNameData.dataset;

    if (productId && compositionName) {
      track("product_detail_zipcode", {
        product_id: parseInt(productId, 10),
        spree_composition_id: parseInt(compositionId, 10),
        composition: compositionName,
        zipcode,
        product: productName
      });
    }
  }
};

const handleSubmit = () => {
  const $form = $getForm();

  $form.addEventListener("submit", async e => {
    e.preventDefault();
    toggleFormLoading(true);

    api.jiffyshirts.locations
      .create({
        zipcode: $getFormInput().value
      })
      .then(data => {
        if (!data.error) {
          const { cities, zipcode } = data;
          const city = Array.isArray(cities) ? cities[0].name : "";

          // send analytics data
          submitSuccessGA("zipcode");
          // send mixpanel data
          registerMixpanel({ zipcode });
          trackPDPZipcode(zipcode);
          window.JiffyDeliverTo.updateZipCodeInHeader({ zipcode, city });
          // hide form
          $form.classList.add("hidden");
          // init delivery dates section
          initDates();
        } else if (data.error) {
          showError(data.message);
        } else {
          showError();
        }
      })
      .catch(() => {
        const message = "Something went wrong. Please try again later.";
        showError(message);
      });
  });
};

const initForm = () => {
  const $container = $getContainer();

  $getSpinner().classList.remove("shown");
  $getForm().classList.remove("hidden");

  // After selecting new color in the color picker, we should update container's data
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, async (evt, { color }) => {
    $container.dataset.selectedColor = color;
  });
  // After selecting saved cart, we should update container's data
  EventBus.on(Events.SAVED_CART_SELECTED, async (evt, { number }) => {
    $container.dataset.selectedCart = number;
  });

  handleSubmit();
};

export default initForm;
